<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">System Time</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the system time and the related configuration." }}
      </p>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--clock time-->
        <pane label="Clock Time">
          <clock-time></clock-time>
        </pane>
        <!--sntp-->
        <pane label="Sntp Config">
          <sntp-config></sntp-config>
        </pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs.vue"
import Pane from "@/components/Pane.vue"
import ClockTime from "@/views/ClockTime.vue"
import SntpConfig from "@/views/SntpConfig.vue"

export default {
  components: {
    Tabs,
    Pane,
    ClockTime,
    SntpConfig,
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
}
</script>

